var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-about mt-5 text-center"},[_c('h1',[_vm._v(" version"+_vm._s(_vm.VERSION)+" ")]),_c('h2',[_vm._v(" v"+_vm._s(_vm.VERSION)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }